/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Rule } from './Rule.js';
import {
    RuleFromJSON,
    RuleFromJSONTyped,
    RuleToJSON,
} from './Rule.js';

/**
 * 
 * @export
 * @interface Section
 */
export interface Section {
    /**
     * 
     * @type {number}
     * @memberof Section
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Section
     */
    scorecardTemplateId?: number;
    /**
     * 
     * @type {string}
     * @memberof Section
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Section
     */
    order?: number;
    /**
     * 
     * @type {Date}
     * @memberof Section
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Section
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Section
     */
    isDraft?: boolean;
    /**
     * 
     * @type {Array<Rule>}
     * @memberof Section
     */
    rules?: Array<Rule>;
}

/**
 * Check if a given object implements the Section interface.
 */
export function instanceOfSection(value: object): boolean {
    return true;
}

export function SectionFromJSON(json: any): Section {
    return SectionFromJSONTyped(json, false);
}

export function SectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Section {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'scorecardTemplateId': json['scorecardTemplateId'] == null ? undefined : json['scorecardTemplateId'],
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
        'rules': json['rules'] == null ? undefined : ((json['rules'] as Array<any>).map(RuleFromJSON)),
    };
}

export function SectionToJSON(value?: Section | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'scorecardTemplateId': value['scorecardTemplateId'],
        'name': value['name'],
        'order': value['order'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'isDraft': value['isDraft'],
        'rules': value['rules'] == null ? undefined : ((value['rules'] as Array<any>).map(RuleToJSON)),
    };
}

